// $(document).ready(function(){

	//shop hover
  	$(".nav-left li.shop-li, .shop-mega").hover(function() {
		$(".nav-left li.shop-li").children("a").addClass("hover-a");
		$(".megamenu").addClass("border-mega");
		$(".shop-mega").stop().fadeIn("fast");
	}, function () {
		$(".nav-left li.shop-li").children("a").removeClass("hover-a");
		$(".megamenu").removeClass("border-mega");
        $(".shop-mega").fadeOut('fast');
  	});

  	//help hover
  	$(".nav-right li.help-li, .help-mega").hover(function() {
		$(".nav-right li.help-li").children("a").addClass("hover-a");
		$(".megamenu").addClass("border-mega");
		$(".help-mega").stop().fadeIn("fast");
	}, function () {
		$(".nav-right li.help-li").children("a").removeClass("hover-a");
		$(".megamenu").removeClass("border-mega");
        $(".help-mega").fadeOut('fast');
  	});

  	//banner click
  	$("#banner").on("click", function(){
  		var url = $(this).attr("banner-url");
  		//console.log(url);
  		window.location.href = url;
  	});

	  $("[data-featured-grid]").on("click", function(){
		var url = $(this).attr("data-featured-grid");
		if(url != '' && url != undefined && url != null) {
			window.location.href = url;
		}	
	});

	$("[data-image-with-text]").on("click", function(){
		var url = $(this).attr("data-image-with-text");
		if(url != '' && url != undefined && url != null) {
			window.location.href = url;
		}		
	});


  	//featured prod
  	$(".box .img, .big-box .img").on("click", function(){
  		var url = $(this).attr("box-url");
  		//console.log(url);
  		window.location.href = url;
  	});




	$(".box-slide").slick({
		infinite: true,
	  	slidesToShow: 1,
	  	slidesToScroll: 1,
	  	arrows: true,
	  	dots: false,
	  	cssEase: 'linear',
    	variableWidth: true,
    	centerMode: false,
	});



	$(".slide-ul-landing").slick({
		infinite: false,
	  	slidesToShow: 4,
	  	slidesToScroll: 1,
	  	arrows: true,
	  	dots: false,
	  	cssEase: 'linear',
    	variableWidth: false,
    	centerMode: false,
		touchThreshold:100,
    	prevArrow: $("button.btn-fcs-prev"),
    	nextArrow: $("button.btn-fcs-next"),
    	responsive: [
    		{
    			breakpoint: 768,
			    settings: {
			        slidesToShow: 2,
			        slidesToScroll: 2,
			        infinite: false,
			        dots: false,
			        variableWidth: true
			    }
    		}
    	]
	});

	$(".slide-ul").slick({
		infinite: false,
	  	slidesToShow: 5,
	  	slidesToScroll: 1,
	  	arrows: true,
	  	dots: false,
	  	cssEase: 'linear',
    	variableWidth: false,
    	centerMode: false,
		touchThreshold:100,
    	prevArrow: $("button.btn-fcs-prev"),
    	nextArrow: $("button.btn-fcs-next"),
    	responsive: [
    		{
    			breakpoint: 768,
			    settings: {
			        slidesToShow: 2,
			        slidesToScroll: 1,
			        infinite: false,
			        dots: true,
			        variableWidth: true
			    }
    		}
    	]
	});
	$(".cat-shop-ul").slick({
		infinite: false,
	  	slidesToShow: 3,
	  	slidesToScroll: 1,
	  	arrows: true,
	  	dots: false,
	  	cssEase: 'linear',
    	variableWidth: true,
    	centerMode: false,
    	prevArrow: $("button.btn-cat-prev"),
    	nextArrow: $("button.btn-cat-next"),
    	responsive: [
    		{
    			breakpoint: 1200,
			    settings: {
			        slidesToShow: 3,
			        slidesToScroll: 1,
			        infinite: false,
			        dots: false,
			        variableWidth: false,
			        centerMode: false
			    }
    		},
    		{
    			breakpoint: 992,
			    settings: {
			        slidesToShow: 3,
			        slidesToScroll: 1,
			        infinite: false,
			        dots: false,
			        variableWidth: false,
			        centerMode: false
			    }
    		},
    		{
    			breakpoint: 768,
			    settings: {
			        slidesToShow: 1,
			        slidesToScroll: 1,
			        infinite: false,
			        dots: true,
			        variableWidth: true,
			        centerMode: false
			    }
    		}
    	]
	});
	$(".image-parent").slick({
		infinite: false,
	  	slidesToShow: 1,
	  	slidesToScroll: 1,
	  	arrows: true,
	  	dots: true,
	  	cssEase: 'linear',
    	variableWidth: false,
    	centerMode: false,
    	prevArrow: $("button.btn-it-prev"),
    	nextArrow: $("button.btn-it-next")
	});
	$(".insta-slider").slick({
		infinite: false,
	  	slidesToShow: 2,
	  	slidesToScroll: 1,
	  	arrows: true,
	  	dots: false,
	  	cssEase: 'linear',
    	variableWidth: true,
    	centerMode: false,
    	prevArrow: $("button.btn-insta-prev"),
    	nextArrow: $("button.btn-insta-next"),
    	responsive: [
    		{
    			breakpoint: 768,
			    settings: {
			        slidesToShow: 1,
			        slidesToScroll: 1,
			        infinite: false,
			        dots: false,
			        variableWidth: true,
			        centerMode: false
			    }
    		}
    	]
	});

	//ship-slider
	$('.ship-slider').slick({
		slidesToShow: 1,
	  	slidesToScroll: 1,
	  	arrows: false,
	  	fade: false,
		infinite: false,
		speed: 1000,
		nav: true,
		dots: true,
		autoplay: true,
		autoplaySpeed: 6000,
    	speed: 600
	});

	//product
	$('.product-slider').slick({
	  	slidesToShow: 1,
	  	slidesToScroll: 1,
	  	arrows: true,
	  	fade: true,
		infinite: false,
		speed: 1000,
		adaptiveHeight: false,
	  	asNavFor: '.thumbnail-slider',
	    arrows: false,
	    swipe: false,
	    responsive: [
	    	{
	    		breakpoint: 768,
	    		settings: {
	    			dots: true,
	    			swipe: true,
	    			focusOnSelect: false,
	    			touchThreshold:300,
	    			fade: false,
	    			infinite: true
	    		}
	    	}
	    ]
	});
	$('.thumbnail-slider').slick({
	  	slidesToShow: 8,
	  	slidesToScroll: 8,
	  	asNavFor: '.product-slider',
	  	dots: false,
	  	focusOnSelect: true
	});

	//product size chart
	$('#size').on('click', function(e) {
	  	e.preventDefault();
	  	$("#sizechart").toggleClass("is-visible");
	  	$("body").toggleClass("body-size");
	});

	$("#sizechart").on('click', function(){
		$("#sizechart").toggleClass("is-visible");
	  	$("body").toggleClass("body-size");
	});

	//faq's
	// $('#help-text').on('click', function(e){
	// 	e.stopPropagation();
	// 	if($(this).siblings('ul').is(':visible')){
	// 		$(this).siblings('ul').slideUp();
	// 		//$(this).siblings('#help-text').removeClass('active');
	// 		$(this).siblings(".dropdown-icon").removeClass('rotate');
	// 	}
	// 	else{
	// 		$(this).siblings('ul').slideDown();
	// 		$(this).siblings('#help-text').addClass('active');
	// 		$(this).siblings(".dropdown-icon").addClass('rotate');
	// 	}
	// });

	$('#help-mobile-menu ul li').on('click', function(e){
		e.stopPropagation();
		//e.preventDefault();
		var liValue = $(this).text();
		$(this).parent().siblings('#help-text').text(liValue);
		$('.dropdown-option').slideUp();
		$('#help-text').removeClass('active');
		$('.dropdown-icon').removeClass('rotate');
	});


	//sizechart
	//tabs
	$('.measure-tabs span').click(function() {
	    // Check for active
	    $('.measure-tabs li').removeClass('measure-active');
	    $(this).parent().addClass('measure-active');

	    // Display active tab
	    let currentTab = $(this).attr('data-tab');
	    //console.log(currentTab);
	    $('.measure-tab-contents .wrapper').hide();
	    $("#"+currentTab).show();
	    return false;
	});

	//subscription box
	// $(".sub-heads").slick({
	// 	slidesToShow: 1,
	//   	slidesToScroll: 1,
	//   	dots: false,
	//   	arrows: false,
	//   	infinite: false,
	//   	swipe: true,
	//   	responsive: [
	//     	{
	//     		breakpoint: 768,
	//     		settings: {
	//     			swipe: false,
	//     			infinite: false
	//     		}
	//     	}
	//     ]
	// });

	// $(".sub-images img").on("click", function(){
	// 	$(".sub-images .img").removeClass("active-img");
	// 	//$("h3").removeClass("h3-active");
	// 	$(this).parent().addClass("active-img");

	// 	let currimg = $(this).attr("data-img");
	// 	//console.log(currimg);
	// 	//$(".h3-"+currimg).addClass("h3-active");
	// 	$("."+currimg+"-img").show();

	// 	var ind = $(this).parent().index();
	// 	$(".sub-heads").slick("slickGoTo", ind);
	// 	//console.log(ind);

	//     return false;
	// });

	$(".sub-heads").on("swipe", function(event, slick, direction){
  		//console.log(slick);
  		if (slick["currentSlide"] == 0) {
  			$(".sub-images .buzzfeed-img img").click();
  		}else if(slick["currentSlide"] == 1){
  			$(".sub-images .us-week-img img").click();
  		}
	});

	//mobile dropdown
	$('#help-text').on('click', function(e){
		e.stopPropagation();
		if($(this).siblings('ul').is(':visible')){
			$(this).siblings('ul').slideUp();
			//$(this).siblings('#help-text').removeClass('active');
			$(this).siblings(".dropdown-icon").removeClass('rotate');
		}
		else{
			$(this).siblings('ul').slideDown();
			$(this).siblings('#help-text').addClass('active');
			$(this).siblings(".dropdown-icon").addClass('rotate');
		}
		
	});

	$('#help-mobile-menu ul li span').on('click', function(e){
		e.stopPropagation();
		e.preventDefault();
		var liValue = $(this).text();
		$(this).parent().siblings('#help-text').text(liValue);
		$('.dropdown-option').slideUp();
		$('#help-text').removeClass('active');
		$('.dropdown-icon').removeClass('rotate');
	});
	

	//accordions
	// if($(".link-title").hasClass('active')){
	// 	$(this).children('svg').find('path:nth-child(2)').hide();
	// }

	$('#help-content .c-button').on('click', function() {
		console.log('yes click');
		if($('#links-accordions .link-none-block').length) {
			$('#links-accordions .link-none-block').each((i, ele) => {
				$(ele).removeClass('d-none');
			});
			if($('.help-boxes .c-button').length) {
				$('.help-boxes .c-button').addClass('d-none');
			}		
		}		
	});

	$('.link-title').on('click', function(){
		if($(this).hasClass('active')){
			$(this).removeClass('active');
			$(this).children('svg').find('path:nth-child(2)').show();
			$(this).siblings('.link-content').slideUp();
		}
		else{
			$('.link-title').removeClass('active');
			$('.link-title').children('svg').find('path:nth-child(2)').show();
			$('.link-content').slideUp();

			$(this).addClass('active');
			$(this).children('svg').find('path:nth-child(2)').hide();
			$(this).siblings('.link-content').slideDown();
		}
	});


	//hamburger
	$("#hamburger button").click(function(){
	    $(".burger-open").toggleClass("opac-0");
	    $(".burger-close").toggleClass("opac-1");
	    $("#hamburger-menu").toggleClass("nav-list-active");
	    $("body").toggleClass("body-over");
	});

	//ajax cart
	$(".cart-btn-head").click(function(e){
		e.preventDefault();
		$("body").addClass("cart-over");
		$("#cart-drawer").addClass("is-open");
		$("#cart-overlay").addClass("is-visible");
		// $(".ajax-checkout").addClass("is-open");
		// $("#shopify-section-cart-drawer");
	});
	$("#cart-overlay, .cart-drawer-close").click(function(){
		$("body").removeClass("cart-over");
		$("#cart-drawer").removeClass("is-open");
		$("#cart-overlay").removeClass("is-visible");
		// $(".ajax-checkout").removeClass("is-open");
	});

	//bundle add to cart	
	window.bundleAddtocart = function(data){	
		//console.log('Data==========>', window.bundledata.length);	
		//$(".summary-build-button button").text("Loading...");	
		Shopify.moveAlong = function() {	
			// If we still have requests in the queue, let's process the next one.	
		    //console.log('Start Function===========++');	
			if (window.bundledata.length){  //from bundle-builder.js	
			    var request = window.bundledata.shift(); //adds 1 by 1	
		        //console.log('request======>', request);	
			    var data = 'id='+ request.id + '&quantity='+request.quantity	
			    $.ajax({	
			      	type: 'POST',	
		            url: '/cart/add.js',	
				    dataType: 'json',	
				    data: data,	
				    success: function(res){	
				      	//console.log('res===========>', res);	
				        Shopify.moveAlong();	
				    },	
	             	error: function(error){	
			            console.log('error=========>', error);	
				     	// if it's not last one Move Along else update the cart number with the current quantity	
					 	if(window.bundledata.length){	
					    	Shopify.moveAlong()	
					  	}else{	
					    	//console.log("Added Successfully");	
					  	}	
			      	}	
		        });	
		    }else{// If the queue is empty, we add 1 to cart	
			  	//console.log('Else Successfully Added');	
			  	//console.log('Ended Function===========++');	
			  	//$(".summary-build-button button").text("Select 5 Tees");	
			  	fetchproducts();	
			}	
       };	
    	Shopify.moveAlong();	
	}


	//addtocart
	function addtocart(id, qty){
		$.ajax({
			type: 'POST',
	        url: '/cart/add.js',
	        data: {
	            quantity: qty,
	            id: id
	        },
	        dataType: 'json',
	        success: function (data) {
	        	console.log('product added');
	        },
	        complete: function(){
	      		fetchproducts();
	      	},
	        error: function(error){
	        	console.log('error');
	        }
		})
		

		// jQuery.post('/cart/add.js', {
	 //        items: [
	 //          {
	 //            id: id,
	 //            quantity: qty
	 //          }
	 //        ]
	 //      }).done(function(cart, textStatus){
	 //      	fetchproducts();
	 //    });
	}

	function fetchproducts(){
		$.ajax({
		type: 'GET',
		url: '/cart.json',
		dataType: 'jsonp',
        cache: false,
        contentType: "application/json",                  
		 	success: function (data) { 
		 		var cart_list = [];
		 		var total = 0;
		 		var original_total_price = 0;
		 		var itemCount = 0;
		 		fetcheddata = data;
		 		total = (fetcheddata.total_price/100).toFixed(2);
		 		original_total_price = (fetcheddata.original_total_price/100).toFixed(2);
		 		itemCount = fetcheddata.item_count;
		 		//console.log(fetcheddata);
		 		fetcheddata.items.forEach(item => {
		    		//console.log(item.title);
		    		var size = "";
		    		if (item.variant_title == "Small"){
					    size = "Small";
					}else if (item.variant_title == "Medium"){
					    size = "Medium";
					}else if (item.variant_title == "Large"){
					    size = "Large";
					}else if (item.variant_title == "Xlarge" || item.variant_title == "XLarge"){
					    size = "XLarge";
					}else if (item.variant_title == "2XLarge"){
					    size = "2XLarge";
					}else if (item.variant_title == "3XLarge" || item.variant_title == "3Xlarge"){
					    size = "3XLarge";
					}else if (item.variant_title == "4XLarge" || item.variant_title == "4Xlarge"){
					    size = "4XLarge";
					}else if (item.variant_title == "5XLarge" || item.variant_title == "5Xlarge"){
					    size = "5XLarge";
					}else{
						size = item.variant_title;
					}
					//console.log(item);
					

					const matches = window.productColors.filter(element => {
						// console.log(element);
					  	if(item.product_title.includes(element)){
					    	return true;
					  	}
					});


					// if(matches.length > 0) {
					//   	console.log(matches);
					// }else{
					// 	console.log("no matches");
					// }


					var color = "";
					var producttitle = "";

					if((item.product_type != "3pack") && (item.product_type != "One-Time 5-Pack")){
						if(matches.length > 0) {
						  	// console.log(matches);
						  	color = matches;
					      	if(matches.includes("Vintage White")){
					      		color="Vintage White";
					      		producttitle = item.product_title.replace(color, '');
					      	}else{
						  		color = matches;
					      		producttitle = item.product_title.replace(color, '');
					      	}
						}else{
							// console.log("no matches");
							producttitle = item.product_title;
						}
					}else{
						producttitle = item.product_title;
					}



					// if ((item.product_type != "3pack") && (item.product_type != "One-Time 5-Pack")) {
					// 	if(item.product_title.includes("Black")){
					//       	color = "Black";
					//       	producttitle = item.product_title.replace(color, '');
					//     }else if(item.product_title.includes("White")){
					//     	color = "White";
					//     	producttitle = item.product_title.replace(color, '');
					//     }else if(item.product_title.includes("Charcoal")){
					//     	color = "Charcoal";
					//     	producttitle = item.product_title.replace(color, '');
					//     }else if(item.product_title.includes("Dark Heather")){
					//     	color = "Dark Heather";
					//     	producttitle = item.product_title.replace(color, '');
					//     }else if(item.product_title.includes("Heather Grey")){
					//     	color = "Heather Grey";
					//     	producttitle = item.product_title.replace(color, '');
					//     }else if(item.product_title.includes("Wedgewood")){
					//     	color = "Wedgewood";
					//     	producttitle = item.product_title.replace(color, '');
					//     }else if(item.product_title.includes("Military")){
					//     	color = "Military";
					//     	producttitle = item.product_title.replace(color, '');
					//     }else if(item.product_title.includes("Navy")){
					//     	color = "Navy";
					//     	producttitle = item.product_title.replace(color, '');
					//     }else if(item.product_title.includes("Ice")){
					//     	color = "Ice";
					//     	producttitle = item.product_title.replace(color, '');
					//     }else if(item.product_title.includes("Sand")){
					//     	color = "Sand";
					//     	producttitle = item.product_title.replace(color, '');
					//     }else if(item.product_title.includes("Emerald")){
					//     	color = "Emerald";
					//     	producttitle = item.product_title.replace(color, '');
					//     }else if(item.product_title.includes("Garnet")){
					//     	color = "Garnet";
					//     	producttitle = item.product_title.replace(color, '');
					//     }else if(item.product_title.includes("Clay")){
					//     	color = "Clay";
					//     	producttitle = item.product_title.replace(color, '');
					//     }else if(item.product_title.includes("Olive")){
					//     	color = "Olive";
					//     	producttitle = item.product_title.replace(color, '');
					//     }else if(item.product_title.includes("Mercury Green")){
					//     	color = "Mercury Green";
					//     	producttitle = item.product_title.replace(color, '');
					//     }else if(item.product_title.includes("Odyssey Blue")){
					//     	color = "Odyssey Blue";
					//     	producttitle = item.product_title.replace(color, '');
					//     }else if(item.product_title.includes("Graphite")){
					//     	color = "Graphite";
					//     	producttitle = item.product_title.replace(color, '');
					//     }else if(item.product_title.includes("Purple Galaxy")){
					//     	color = "Purple Galaxy";
					//     	producttitle = item.product_title.replace(color, '');
					//     }else if(item.product_title.includes("Storm Blue")){
					//     	color = "Storm Blue";
					//     	producttitle = item.product_title.replace(color, '');
					//     }else{
					//     	producttitle = item.product_title;
					//     }
					// }else{
					// 	producttitle = item.product_title;
					// }

					var disc = item.discounts;
					var disc_title = "";
					//console.log(disc)
                 
					for (var x = disc.length - 1; x >= 0; x--) {
                      let discountTitle = disc[x].title;
                      discountTitle = discountTitle.replace(/[()]/g, '').replace(/-\$/g, '- \$').replace(/\s+/g, ' ');
                      if(discountTitle == 'Bundle Discount') {
                        disc_title = `<p class="ajax-discount">(${disc[x].title} - $3.00)</p>`;
                      } else {
                        disc_title = '<p class="ajax-discount">('+discountTitle + ')</p>';
                      }
					}
					//console.log("item.discounted_price: "+item.discounted_price);
					//console.log("item.final_price: "+item.final_price);
					var cart_Discountprice = "";
					if (item.discounted_price < item.original_price){
						cart_Discountprice = `<p class="ajax-final-price"><del>$`+((item.quantity)*(item.original_price/100)).toFixed(2)+`</del></p>`;
					}

					let priceItem = `<p class="ajax-price">$`+((item.quantity)*(item.discounted_price/100)).toFixed(2)+`</p>`;
                    if (item.product_type == "Free Gift") {
						priceItem = `<p class="ajax-price" style="color:#cb4b4b;text-transform: uppercase;">Free</p>`;
                    }/*else{
                    	priceItem = '$'+((item.quantity)*(item.final_price/100)).toFixed(2);
                    }*/


					
		    		cart_list.push('<div class="cart-item-box">'+
		    		'<ul class="flex_box ajax-cart-item"><li class="cart-image">'+
		    		'<a class="ajax-image">'+
		    			'<img src='+item.image+' | img_url: 320x" alt='+item.product_title+' | escape" />'+
		    		'</a>'+
		    		'</li>'+
		    		'<li class="cart-descr">'+
		    		'<a class="ajax-title">'+producttitle+'</a>'+
		    		'<p class="ajax-color">'+color+'</p>'+
		    		'<p class="ajax-size" style="text-transform: capitalize;">'+size+'</p>'+
		    		'<div class="qty-box">'+
		    		'<div class="cart-quantity">'+
		    		'<div class="control minus-control" variant-id="'+item.id+'">'+
		    		'<span class="qty-minus" data-update-quantity="minus">-</span>'+
		    		'</div>'+
		    		'<div class="control qty-control">'+
		    		'<input class="qty-input" type="number" min="1" name="updates[]" id="updates_'+item.key+' size="2" value='+item.quantity+' data-id='+item.key+' /></div>'+
		    		'<div class="control plus-control" variant-id="'+item.id+'" ><span class="qty-plus" data-update-quantity="plus">+</span></div></div></div></li>'+
		    		'<li class="cart-price">'+
		    		cart_Discountprice+	
		    		priceItem+	
		    		disc_title+	
		    		'</li></ul>'+
		    		'<div class="cart-delete" data-id="'+item.id+'"><a href="/cart/change?line=&amp;quantity=0">'+
		    		'<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">'+
		    		'<path d="M15.8312 19.8343H5.16786C4.94339 19.829 4.72216 19.7795 4.51682 19.6887C4.31147 19.5978 4.12604 19.4674 3.97111 19.3049C3.81617 19.1424 3.69478 18.951 3.61387 18.7415C3.53295 18.5321 3.4941 18.3087 3.49952 18.0843V6.55176H4.66619V18.0843C4.66062 18.1555 4.6692 18.2272 4.69143 18.2952C4.71366 18.3631 4.7491 18.426 4.79573 18.4802C4.84235 18.5344 4.89922 18.5789 4.96309 18.6111C5.02695 18.6432 5.09654 18.6624 5.16786 18.6676H15.8312C15.9025 18.6624 15.9721 18.6432 16.036 18.6111C16.0998 18.5789 16.1567 18.5344 16.2033 18.4802C16.2499 18.426 16.2854 18.3631 16.3076 18.2952C16.3298 18.2272 16.3384 18.1555 16.3329 18.0843V6.55176H17.4995V18.0843C17.5049 18.3087 17.4661 18.5321 17.3852 18.7415C17.3043 18.951 17.1829 19.1424 17.0279 19.3049C16.873 19.4674 16.6876 19.5978 16.4822 19.6887C16.2769 19.7795 16.0557 19.829 15.8312 19.8343Z" fill="#908F8F"/><path d="M17.9547 5.24967H2.91634C2.76163 5.24967 2.61326 5.18822 2.50386 5.07882C2.39447 4.96942 2.33301 4.82105 2.33301 4.66634C2.33301 4.51163 2.39447 4.36326 2.50386 4.25386C2.61326 4.14447 2.76163 4.08301 2.91634 4.08301H17.9547C18.1094 4.08301 18.2578 4.14447 18.3672 4.25386C18.4765 4.36326 18.538 4.51163 18.538 4.66634C18.538 4.82105 18.4765 4.96942 18.3672 5.07882C18.2578 5.18822 18.1094 5.24967 17.9547 5.24967Z" fill="#908F8F"/><path d="M12.249 7.58301H13.4157V16.333H12.249V7.58301Z" fill="#908F8F"/><path d="M7.58301 7.58301H8.74967V16.333H7.58301V7.58301Z" fill="#908F8F"/><path d="M13.4163 3.41866H12.308V2.33366H8.69134V3.41866H7.58301V2.33366C7.58263 2.03409 7.69751 1.74585 7.90384 1.52866C8.11017 1.31147 8.39214 1.18197 8.69134 1.16699H12.308C12.6072 1.18197 12.8892 1.31147 13.0955 1.52866C13.3018 1.74585 13.4167 2.03409 13.4163 2.33366V3.41866Z" fill="#908F8F"/></svg></a></div></div>');
		    		
		    	});
		    	$('.ajax-cart').html(cart_list.join(''));
		    	if(itemCount > 1){
		    		$('.item_counter').text(itemCount + ' items');
		    	}else{
		    		$('.item_counter').text(itemCount + ' item');
		    	}
		    	if(itemCount > 0){
		    		$('.empty-cart-content').css('display','none');
		    		$('#cart-form').css('display','block');
		    	}else{
		    		$('.empty-cart-content').css('display','block');
		    		$('#cart-form').css('display','none');
		    	}


		    	//only free shipping bar
		   		var onlyFreeAmt=parseInt($("#free-ship-only-amt").val());
		   		var onlyfreeShipping = parseInt((original_total_price/onlyFreeAmt)*100).toFixed(0);
		   		// console.log(onlyFreeAmt);

		    	if(total<onlyFreeAmt){
		    		//console.log("fetchproducts else");
		    		$(".only-free-ship .disc-main-bar").addClass("hasItems");
		    		$('.only-free-ship.free-disc-amount').text(0);
		    		//$(".disc-"+th1).addClass("active-point");
		    		//$(".disc-"+th2).addClass("active-point");
		    		//$(".disc-progress-filled").removeClass("active-point");
		    		$('.only-free-ship.discount-ship > p').html(`You're only <span class="free-disc-amount" id="disc-amount">$${onlyFreeAmt-total}.00</span> away from <span>Free Shipping</span>`);

		    		setTimeout(function () {
		    			$(".only-free-ship .disc-progress-filled").addClass("full-disc");
		    			$(".only-free-ship .disc-th-point").addClass("active-point").show();
		    		}, 200);
		    		$('.only-free-ship .disc-progress-filled').removeClass('ship-fill-green');
		    		$(".only-free-ship .disc-tag svg path").css("fill", "#cb4b4b");
		    		//$(".disc-progress-filled").addClass("full-disc");
		    		//$(".disc-th-point").addClass("active-point");
		    		$('.only-free-ship.disc-progress-empty .disc-progress-filled .progress-marker').css("visibility", "hidden");
		    		$(".only-free-ship.discount-ship .progress-bar").removeClass("ship-marg-not");
	    			$(".only-free-ship.discount-ship .progress-bar").addClass("ship-marg");
		    		$(".only-free-ship.discount-ship .disc-main-bar").css({"height":"33px", "border-radius" : "0px"});
		    	}else{
		    		//console.log("fetchproducts else");
		    		$(".only-free-ship .disc-main-bar").addClass("hasItems");
		    		$('.only-free-ship.free-disc-amount').text(0);
		    		//$(".disc-"+th1).addClass("active-point");
		    		//$(".disc-"+th2).addClass("active-point");
		    		//$(".disc-progress-filled").removeClass("active-point");
		    		$('.only-free-ship.discount-ship > p').html("YOU'VE UNLOCKED <span>FREE SHIPPING</span>");
		    		setTimeout(function () {
		    			$(".only-free-ship .disc-progress-filled").addClass("full-disc");
		    			$(".only-free-ship .disc-th-point").addClass("active-point").hide();
		    		}, 200);
		    		$('.only-free-ship .disc-progress-filled').addClass('ship-fill-green');
		    		$(".only-free-ship .disc-tag svg path").css("fill", "#39a33e");
		    		//$(".disc-progress-filled").addClass("full-disc");
		    		//$(".disc-th-point").addClass("active-point");
		    		$('.only-free-ship.disc-progress-empty .disc-progress-filled .progress-marker').css("visibility", "hidden");
		    		$(".only-free-ship.discount-ship .progress-bar").removeClass("ship-marg-not");
	    			$(".only-free-ship.discount-ship .progress-bar").addClass("ship-marg");
		    		$(".only-free-ship.discount-ship .disc-main-bar").css({"height":"13px", "border-radius" : "100px"});
		    	}
		    	$('.only-free-ship .disc-progress-empty .disc-progress-filled').css('width',onlyfreeShipping+'%');
		    	$('.only-free-ship .disc-progress-empty .disc-progress-filled .progress-marker').text('$'+onlyfreeShipping);




		    	var free_amt = parseInt($("#cart-drawer #free-amt").val());
				var free_discount_amt = parseInt($("#cart-drawer #free-disc-amt").val());
				var discountCode = $("#cart-drawer #disc-code").val();
				var freeShipping = (original_total_price/free_amt)*100;

		    	if(total < free_amt){
					// console.log('if wwwwwewe');
		    		$('.free-shipping-amount').text(free_amt - total);
		    		$('.shipping-bar > p').html('You\'re <span class="free-shipping-amount" id="ship-amount">$'+(free_amt - total)+'.00</span> away from <span id="ship-amount">'+free_discount_amt+'% OFF</span> ');
					$('.progress-filled').addClass('ship-fill');
					$('.progress-filled').removeClass('ship-fill-green');
					$('.cart-shipping-bar.shipping-bar').find(".disc-th-point").removeClass('active-green-point');
					$('.cart-shipping-bar.shipping-bar').find('.disc-tag').find('path.fill-svg').css("stroke", "#BD5450");
					$('.cart-shipping-bar.shipping-bar').find('.disc-tag').find('path.dot-svg').css("fill", "#BD5450");
		    	}else{
					// console.log('else wwwwewe');
		    		$('.free-shipping-amount').text(0);
					$('.shipping-bar > p').html("You've Unlocked <span>"+free_discount_amt+"% OFF</span><br/>Use Code: <span class='discount-code'>"+discountCode+"</span>");
					$('.progress-filled').addClass('ship-fill-green');
					$('.progress-filled').removeClass('ship-fill');						
					$('.cart-shipping-bar.shipping-bar').find(".disc-th-point").addClass('active-green-point');
					$('.cart-shipping-bar.shipping-bar').find('.disc-tag').find('path.fill-svg').css("stroke", "#38ae3a");
					$('.cart-shipping-bar.shipping-bar').find('.disc-tag').find('path.dot-svg').css("fill", "#38ae3a");
		    	}
		    	
		    	$('.progress-empty .progress-filled').css('width',freeShipping+'%');


		    	//discount shipping bar
		    	var threshold_amt_2 = parseInt($("#cart-drawer #threshold-amt-2").val());
		    	var discount_amt = parseInt($("#cart-drawer #discount-amt").val());
		    	var discountShip = (total/threshold_amt_2)*100;
		    	//console.log("fetchproducts: "+threshold_amt_1);
		    	//console.log("fetchproducts: "+threshold_amt_2);
		    	//console.log("fetchproducts: "+discountShip);
		    	var th1 = $("#cart-drawer #threshold-amt-1").val();
		   		var th2 = $("#cart-drawer #threshold-amt-2").val();


		   		if(original_total_price < threshold_amt_2){
		    		//console.log("fetchproducts if");
		    		$('.free-disc-amount').text(threshold_amt_2 - original_total_price);
		    		$(".discount-ship .progress-bar").removeClass("ship-marg");
	    			$(".discount-ship .progress-bar").addClass("ship-marg-not");
		    		$(".discount-ship .disc-main-bar").css({"height":"33px", "border-radius" : "0px"});
		    		$(".disc-progress-filled").addClass("active-point");
		    		$('.disc-progress-empty .disc-progress-filled .progress-marker').css("visibility", "visible");
		    		//$(".disc-"+th1).removeClass("active-point");
		    		$(".disc-th-point").removeClass("active-point");
		    		$(".disc-progress-filled").removeClass("full-disc");
		    		$('.discount-ship > p').html('You\'re only <span class="free-disc-amount" id="disc-amount">$'+(threshold_amt_2 - original_total_price)+'</span> away from <span>'+discount_amt+'% Off</span>');

		    		// if(total>=threshold_amt_1) {
			    	// 	$(".disc-"+th1).addClass("active-point");
			    	// }else{
			    	// 	$(".disc-"+th1).removeClass("active-point");
			    	// }
		    	}else{
		    		//console.log("fetchproducts else");
		    		$('.only-discount-ship.free-disc-amount').text(0);
		    		//$(".disc-"+th1).addClass("active-point");
		    		//$(".disc-"+th2).addClass("active-point");
		    		//$(".disc-progress-filled").removeClass("active-point");
		    		$('.only-discount-ship.discount-ship > p').html('You got <span>'+discount_amt+'% Off</span> at checkout!');
		    		setTimeout(function () {
		    			$(".only-discount-ship .disc-progress-filled").addClass("full-disc");
		    			$(".only-discount-ship .disc-th-point").addClass("active-point");
		    		}, 200);
		    		//$(".disc-progress-filled").addClass("full-disc");
		    		//$(".disc-th-point").addClass("active-point");
		    		$('.only-discount-ship.disc-progress-empty .disc-progress-filled .progress-marker').css("visibility", "hidden");
		    		$(".only-discount-ship.discount-ship .progress-bar").removeClass("ship-marg-not");
	    			$(".only-discount-ship.discount-ship .progress-bar").addClass("ship-marg");
		    		$(".only-discount-ship.discount-ship .disc-main-bar").css({"height":"13px", "border-radius" : "100px"});
		    	}
		    	$('.only-discount-ship .disc-progress-empty .disc-progress-filled').css('width',discountShip+'%');
		    	$('.only-discount-ship .disc-progress-empty .disc-progress-filled .progress-marker').text('$'+discountShip);
		    	
		    	$('.cart-btn-head .count').text(itemCount);
		    	if(total < original_total_price){	
		    		$('#ajax-original-total').text('$'+original_total_price);	
		    		$('#ajax-original-total').show();	
		    	}else{	
		    		$('#ajax-original-total').text('$'+original_total_price);	
		    		$('#ajax-original-total').hide();	
		    	}	
		    	$('#ajax-total').text('$'+total);
		    	opendrawer();
		 	},
		 	error: "failed"
		});
	}

	function opendrawer(){
		$("body").addClass("cart-over");
		$("#cart-drawer").addClass("is-open");
		$("#cart-overlay").addClass("is-visible");
	}

	// function deleteproduct(id, qty){
 //       jQuery.post('/cart/change.js', { quantity: 0, line: id });
	// }

	// $(".cart-delete a").click(function(e){
	// 	preventDefault();
	// 	deleteproduct(0, 40144250667167);
	// });

	$(".btn-ajaxcart").click(function(e){ 
		e.preventDefault();

		var var_id = $(".productSelect").val();
		var qty = $("#qty").val();
		addtocart(var_id, qty);

	}); 

	$(document).on('click','.cart-delete', function(e){
		e.preventDefault();
		var vid = $(this).attr('data-id');
		deleteProduct(vid);
	});


$(document).on('click','.minus-control', function(){
	var vid = $(this).attr('variant-id');
	var qty = parseInt($(this).siblings('.qty-control').children('input').val()) - 1;
	productQuantityUpdate(vid,qty);
});

$(document).on('click','.plus-control', function(){
	var vid = $(this).attr('variant-id');
	var qty = parseInt($(this).siblings('.qty-control').children('input').val()) + 1;
	productQuantityUpdate(vid,qty);
})



// Quantity increment and decrement
function productQuantityUpdate(id,quantity){
	$.ajax({
		type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
            quantity: quantity,
            id: id
        },
        success: function (data){
			console.log('success');
        },
      	complete: function(){
      		fetchproducts();
      	},
        error: function(error){
        	console.log(error)
        }
	});
}


// Initial cart data fetch

function cartDataCheckOnLoad(){
	$.ajax({
		type: 'GET',
		url: '/cart.json',
		dataType: 'jsonp',
        cache: false,
        contentType: "application/json",                  
	 	success: function (data) {
	 		cartData = data;
	 		var total = (cartData.total_price/100).toFixed(2);
	 		var original_total_price = (cartData.original_total_price/100).toFixed(2);
	 		var itemCount = cartData.item_count;
	 		if(itemCount > 0){
	    		$('.empty-cart-content').css('display','none');
	    		$('#cart-form').css('display','block');
	    	}else{
	    		$('.empty-cart-content').css('display','block');
	    		$('#cart-form').css('display','none');
	    	}


	    	//only free shipping bar
	   		var onlyFreeAmt=parseInt($("#free-ship-only-amt").val());
	   		var onlyfreeShipping = parseInt((original_total_price/onlyFreeAmt)*100).toFixed(0);
	   		// console.log(onlyFreeAmt);

	    	if(original_total_price<onlyFreeAmt){
	    		//console.log("fetchproducts else");
	    		$(".only-free-ship .disc-main-bar").addClass("hasItems");
	    		$('.only-free-ship.free-disc-amount').text(0);
	    		//$(".disc-"+th1).addClass("active-point");
	    		//$(".disc-"+th2).addClass("active-point");
	    		//$(".disc-progress-filled").removeClass("active-point");
	    		$('.only-free-ship.discount-ship > p').html(`You're only <span class="free-disc-amount" id="disc-amount">$${onlyFreeAmt-total}.00</span> away from <span>Free Shipping</span>`);

	    		setTimeout(function () {
	    			$(".only-free-ship .disc-progress-filled").addClass("full-disc");
	    			$(".only-free-ship .disc-th-point").addClass("active-point").show();
	    		}, 200);
	    		$('.only-free-ship .disc-progress-filled').removeClass('ship-fill-green');
	    		$(".only-free-ship .disc-tag svg path").css("fill", "#cb4b4b");
	    		//$(".disc-progress-filled").addClass("full-disc");
	    		//$(".disc-th-point").addClass("active-point");
	    		$('.only-free-ship.disc-progress-empty .disc-progress-filled .progress-marker').css("visibility", "hidden");
	    		$(".only-free-ship.discount-ship .progress-bar").removeClass("ship-marg-not");
    			$(".only-free-ship.discount-ship .progress-bar").addClass("ship-marg");
	    		$(".only-free-ship.discount-ship .disc-main-bar").css({"height":"33px", "border-radius" : "0px"});
	    	}else{
	    		//console.log("fetchproducts else");
	    		$(".only-free-ship .disc-main-bar").addClass("hasItems");
	    		$('.only-free-ship.free-disc-amount').text(0);
	    		//$(".disc-"+th1).addClass("active-point");
	    		//$(".disc-"+th2).addClass("active-point");
	    		//$(".disc-progress-filled").removeClass("active-point");
	    		$('.only-free-ship.discount-ship > p').html("YOU'VE UNLOCKED <span>FREE SHIPPING</span>");
	    		setTimeout(function () {
	    			$(".only-free-ship .disc-progress-filled").addClass("full-disc");
	    			$(".only-free-ship .disc-th-point").addClass("active-point").hide();
	    		}, 200);
	    		$('.only-free-ship .disc-progress-filled').addClass('ship-fill-green');
	    		$(".only-free-ship .disc-tag svg path").css("fill", "#39a33e");
	    		//$(".disc-progress-filled").addClass("full-disc");
	    		//$(".disc-th-point").addClass("active-point");
	    		$('.only-free-ship.disc-progress-empty .disc-progress-filled .progress-marker').css("visibility", "hidden");
	    		$(".only-free-ship.discount-ship .progress-bar").removeClass("ship-marg-not");
    			$(".only-free-ship.discount-ship .progress-bar").addClass("ship-marg");
	    		$(".only-free-ship.discount-ship .disc-main-bar").css({"height":"13px", "border-radius" : "100px"});
	    	}
	    	$('.only-free-ship .disc-progress-empty .disc-progress-filled').css('width',onlyfreeShipping+'%');
	    	$('.only-free-ship .disc-progress-empty .disc-progress-filled .progress-marker').text('$'+onlyfreeShipping);




	    	var free_amt = parseInt($("#cart-drawer #free-amt").val());
			var free_discount_amt = parseInt($("#cart-drawer #free-disc-amt").val());
			var discountCode = $("#cart-drawer #disc-code").val();
	    	var freeShipping = (original_total_price/free_amt)*100;

	    	if(original_total_price < free_amt){	
	    		$('.free-shipping-amount').text(free_amt - original_total_price);
	    		$('.shipping-bar > p').html('You\'re <span class="free-shipping-amount" id="ship-amount">$'+(free_amt - original_total_price)+'.00</span> away from <span id="ship-amount">'+free_discount_amt+'% OFF</span>');
				$('.progress-filled').addClass('ship-fill');
				$('.progress-filled').removeClass('ship-fill-green');
				$('.cart-shipping-bar.shipping-bar').find(".disc-th-point").removeClass('active-green-point');
				$('.cart-shipping-bar.shipping-bar').find('.disc-tag').find('path.fill-svg').css("stroke", "#BD5450");
				$('.cart-shipping-bar.shipping-bar').find('.disc-tag').find('path.dot-svg').css("fill", "#BD5450");				
	    	}else{
	    		$('.free-shipping-amount').text(0);
				$('.shipping-bar > p').html("You've Unlocked <span>"+free_discount_amt+"% OFF</span><br/>Use Code: <span class='discount-code'>"+discountCode+"</span>");
				$('.progress-filled').addClass('ship-fill-green');
				$('.progress-filled').removeClass('ship-fill');		
				$('.cart-shipping-bar.shipping-bar').find(".disc-th-point").addClass('active-green-point');
				$('.cart-shipping-bar.shipping-bar').find('.disc-tag').find('path.fill-svg').css("stroke", "#38ae3a");
				$('.cart-shipping-bar.shipping-bar').find('.disc-tag').find('path.dot-svg').css("fill", "#38ae3a");
	    	}
	    	$('.progress-empty .progress-filled').css('width',freeShipping+'%');


	    	//discount shipping bar
	    	var threshold_amt_2 = parseInt($("#cart-drawer #threshold-amt-2").val());
	    	var discount_amt = parseInt($("#cart-drawer #discount-amt").val());
	    	var discountShip = (original_total_price/threshold_amt_2)*100;
	    	//console.log("cartDataCheckOnLoad: "+threshold_amt_1);
	    	//console.log("cartDataCheckOnLoad: "+threshold_amt_2);
	    	//console.log("cartDataCheckOnLoad: "+discountShip);
	    	var th1 = $("#cart-drawer #threshold-amt-1").val();
	    	var th2 = $("#cart-drawer #threshold-amt-2").val();
	    	

	    	if (original_total_price < threshold_amt_2){
	    		//console.log("cartDataCheckOnLoad if");
	    		$('.free-disc-amount').text(threshold_amt_2 - original_total_price);
	    		$(".discount-ship .progress-bar").removeClass("ship-marg");
	    		$(".discount-ship .progress-bar").addClass("ship-marg-not");
	    		$(".discount-ship .disc-main-bar").css({"height":"33px", "border-radius" : "0px"});
	    		$(".disc-progress-filled").addClass("active-point");
	    		$('.disc-progress-empty .disc-progress-filled .progress-marker').css("visibility", "visible");
	    		//$(".disc-"+th1).removeClass("active-point");
	    		$(".disc-th-point").removeClass("active-point");
	    		$(".disc-progress-filled").removeClass("full-disc");
	    		$('.discount-ship > p').html('You\'re only <span class="free-disc-amount" id="disc-amount">$'+(threshold_amt_2 - original_total_price)+'</span> away from <span>'+discount_amt+'% Off</span>');

	    		// if(total>=threshold_amt_1) {
		    	// 	$(".disc-"+th1).addClass("active-point");
		    	// }else{
		    	// 	$(".disc-"+th1).removeClass("active-point");
		    	// }
	    	}else{
	    		//console.log("cartDataCheckOnLoad else");
	    		$('.only-discount-ship.free-disc-amount').text(0);
	    		//$(".disc-"+th1).addClass("active-point");
	    		//$(".disc-"+th2).addClass("active-point");
	    		$('.only-discount-ship.discount-ship > p').html('You got <span>'+discount_amt+'% Off</span> at checkout!');
	    		setTimeout(function () {
	    			$(".only-discount-ship.disc-progress-filled").addClass("full-disc");
	    			$(".only-discount-ship.disc-th-point").addClass("active-point");
	    		}, 200);
	    		//$(".disc-progress-filled").addClass("full-disc");
	    		//$(".disc-th-point").addClass("active-point");
	    		$('.only-discount-ship.disc-progress-empty .disc-progress-filled .progress-marker').css("visibility", "hidden");
	    		$(".only-discount-ship.discount-ship .progress-bar").removeClass("ship-marg-not");
	    		$(".only-discount-ship.discount-ship .progress-bar").addClass("ship-marg");
	    		$(".only-discount-ship.discount-ship .disc-main-bar").css({"height":"13px", "border-radius" : "100px"});
	    	}


	    	$('.only-discount-ship .disc-progress-empty .disc-progress-filled').css('width',discountShip+'%');
	    	$('.only-discount-ship .disc-progress-empty .disc-progress-filled .progress-marker').text('$'+discountShip);
	 	 },
	 	 
	 	 error: function(err){
	 	 	console.log(err);
	 	 }
	 })
}


cartDataCheckOnLoad();





// delete added product from cart

	function deleteProduct(id){
		$.ajax({
			type: 'POST',
	        url: '/cart/change.js',
	        dataType: 'json',
	        data: {
	            quantity: 0,
	            id: id
	        },
	        success: function (data){
				console.log('success');
	        },
	      	complete: function(){
	      		fetchproducts();
	      	},
	        error: function(error){
	        	console.log(error)
	        }
		});

	}

//cat page inc dec
$(".td-cart-dec").on("click",function(){
	//console.log("dec clicked");
	var inp = $(this).siblings("input").val();
    if (inp > 1) {
      inp--;
    }
    $(this).siblings("input").val(inp);
});

$(".td-cart-inc").on("click",function(){
	//console.log("inc clicked");
	var inp = $(this).siblings("input").val();
    inp++;
    $(this).siblings("input").val(inp);
});

	//sticky header
	$(window).scroll(function(){
	  if ($(window).scrollTop() >= 42) {
	    $('.header-parent').addClass('head-fixed');
	    $('#breadcrumb').addClass('breadcrumb-sticky');
	    $('#banner').addClass('banner-sticky');
	    $('#all-collections').addClass('allcollect-sticky');
	    $('#collection-bar').addClass('collect-bar-sticky');
	    $('.no-collect-bar').addClass('no-collect-sticky');
	    $('.build-head').addClass('build-bar-sticky'); //bundle builder
	    $('#help-banner').addClass('help-sticky');
	    $('#seas').addClass('seas-sticky');
	    $('#size-banner').addClass('size-sticky');
	    $('#cart-page').addClass('cart-sticky');
	   }
	   else {
	    $('.header-parent').removeClass('head-fixed');
	    $('#breadcrumb').removeClass('breadcrumb-sticky');
	    $('#banner').removeClass('banner-sticky');
	    $('#all-collections').removeClass('allcollect-sticky');
	    $('#collection-bar').removeClass('collect-bar-sticky');
	    $('.no-collect-bar').removeClass('no-collect-sticky');
	    $('.build-head').removeClass('build-bar-sticky'); //bundle builder
	    $('#help-banner').removeClass('help-sticky');
	    $('#seas').removeClass('seas-sticky');
	    $('#size-banner').removeClass('size-sticky');
	    $('#cart-page').removeClass('cart-sticky');
	   }
	});


	//collection page size swatches quick shop start
	$("li.grid .collectSelect option").each(function(){
	    var option_value =$(this ).val();
	    var option_text = $(this).text();
	    var option_text1 = $(this).text();
	    var option_stock = $(this).attr("stock");
	    //console.log(option_value, option_text, option_stock);
	   
	   	if (option_text.includes(" / ")) {
	   		var option_value_split = option_text.split(" / ");
	    	//console.log(option_value_split[0], option_value_split[1]);

	    	if (option_value_split[1] == "Small" || option_value_split[1] == "small") {
	    		option_value_split[1] = "S";
	    	}else if(option_value_split[1] == "Medium" || option_value_split[1] == "medium"){
	    		option_value_split[1] = "M";
	    	}else if(option_value_split[1] == "Large" || option_value_split[1] == "large"){
	    		option_value_split[1] = "L";
	    	}else if(option_value_split[1] == "XLarge" || option_value_split[1] == "Xlarge" || option_value_split[1] == "xlarge" || option_value_split[1] == "xLarge"){
	    		option_value_split[1] = "XL";
	    	}else if(option_value_split[1] == "2XLarge" || option_value_split[1] == "2xlarge" || option_value_split[1] == "2xLarge" || option_value_split[1] == "2Xlarge"){
	    		option_value_split[1] = "2XL";
	    	}else if(option_value_split[1] == "3XLarge" || option_value_split[1] == "3xlarge" || option_value_split[1] == "3xLarge" || option_value_split[1] == "3Xlarge"){
	    		option_value_split[1] = "3XL";
	    	}else if(option_value_split[1] == "4XLarge" || option_value_split[1] == "4xlarge" || option_value_split[1] == "4xLarge" || option_value_split[1] == "4Xlarge"){
	    		option_value_split[1] = "4XL";
	    	}else if(option_value_split[1] == "5XLarge" || option_value_split[1] == "5xlarge" || option_value_split[1] == "5xLarge" || option_value_split[1] == "5Xlarge"){
	    		option_value_split[1] = "5XL";
	    	}else{
	    		option_value_split[1];
	    	}

	    	if ((option_value_split[0] === "crew") || (option_value_split[0] === "Crew")) {
	    		//console.log(option_value_split[0]);
	    		var sw_parent = $(this).parent().siblings(".pack-size-swatch-main").find(".swatch-crew-tab");
	    		//console.log(sw_parent);
	    		//on collection page
	    		$(sw_parent).append(`
	    			<div variant-id="${option_value}" class="pack-product swatch-box ${option_stock}">
	    				<span>${option_value_split[1]}</span>
	    			</div>
	    		`);
	    	}else if ((option_value_split[0] === "v-neck") || (option_value_split[0] === "V-Neck") || (option_value_split[0] === "V-neck") || (option_value_split[0] === "v-Neck")) {
	    		//console.log(option_value_split[0]);
	    		//on collection page
	    		var sw_parent = $(this).parent().siblings(".pack-size-swatch-main").find(".swatch-v-neck-tab");
	    		//console.log(sw_parent);
	    		//on collection page
	    		$(sw_parent).append(`
	    			<div variant-id="${option_value}" class="pack-product swatch-box ${option_stock}">
	    				<span>${option_value_split[1]}</span>
	    			</div>
	    		`);
	    	}
	    }
	});


	$(".quick-shop").on("click", function(){
		//console.log("quick click");
		$(this).addClass("quick-shop-not-visible");
		$(this).siblings(".swatch-boxes-main").addClass("swatch-visible");

		$(this).siblings(".pack-boxes-swatch-main").addClass("swatch-visible");
	});

	//pack swatches quickshop
	$(".pack-boxes-swatch-main .pack-swatch").on("click", function(){
		// Check for active
		$(".pack-size-swatch-main").removeClass("swatch-visible");
		$(".pack-size-swatch-main .swatch-boxes-ul").removeClass("active-pack");
		$(this).parent().addClass("active-pack");

		// Display active tab
	    let currtab = $(this).attr("data-tab");
	    //console.log(currtab);
	    //console.log(currentTab);
	    var pack_click = $(this).parent().parent().siblings(".pack-size-swatch-main").find(".swatch-"+currtab+"-tab");
	    //console.log(pack_click);
	    $(this).parent().parent().siblings(".pack-size-swatch-main").children(".swatch-boxes-ul").hide();
	    $(this).parent().parent().siblings(".pack-size-swatch-main").addClass("swatch-visible");
	    $(this).parent().parent().siblings(".pack-size-swatch-main").find(".swatch-"+currtab+"-tab").show();
	    return false;
	});


	$(".single-product, .pack-product").on('click', function(){
		//console.log("swatch click");
		var id = $(this).attr("variant-id");
		addtocart(id, 1);
	});

	$("li.grid").mouseleave(function(){
		$(this).find(".quick-shop").removeClass("quick-shop-not-visible");
		$(this).find(".swatch-boxes-main").removeClass("swatch-visible");

		$(".pack-size-swatch-main .swatch-crew-tab").addClass("active-pack");
		$(".pack-size-swatch-main").removeClass("swatch-visible");
		$(".pack-size-swatch-main .swatch-v-neck-tab").hide();
		$(this).find(".pack-boxes-swatch-main").removeClass("swatch-visible");
	});
	//collection page size swatches quick shop end

	/*cart drawer recommended start*/
	$(".select-dropdown .select-selected").on("click", function(e){
		e.stopPropagation();
		if($(this).siblings(".select-items").is(':visible')){
			$(this).siblings(".select-items").addClass("select-hide");
		}else{
			$(this).siblings(".select-items").removeClass("select-hide");	
		}
	});

	$(document).on("click", function(e){
		e.stopPropagation();
		$(".select-items").addClass("select-hide");
	});

	var var_id = "";
	$(".select-items div").on("click", function(){
		var text = $(this).text();
		var_id = $(this).attr("value");

		$(".select-items div").each(function(){
			if($(this).hasClass("same-as-selected")){
				$(this).removeClass("same-as-selected");
			}
		});
		$(this).addClass("same-as-selected");
		$(this).parent().siblings(".select-selected").text(text).attr("variant-id", var_id);
		$(this).parent().addClass("select-hide");

		$(this).parent().parent().siblings(".select-size").children(".select-size-btn").hide();
		$(this).parent().parent().siblings(".select-size").children(".select-add-btn").text("Add To Cart").css({"background-color":"#242424", "border-color": "#242424"});
		$(this).parent().parent().siblings(".select-size").children(".select-add-btn").show();
		return false;
	});

	// var selectval = "";
	// $(".select-size-dropdown").on('change', function(){
	// 	//console.log("changed");
	// 	selectval = $(this).val();
	// 	$(this).parent().siblings(".select-size").children(".select-size-btn").hide();
	// 	$(this).parent().siblings(".select-size").children(".select-add-btn").show();
	// });
	$(".select-add-btn").on('click', function(e){
		e.preventDefault();
		addtocart(var_id, 1);
		$(this).html('<span class="check-svg"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.99826.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" fill="currentColor"></path></svg></span><span>Added To Cart</span>').css({"background-color":"#8D8D8C", "border-color": "#8D8D8C"});
	});
	/*cart drawer recommended end*/

	/*pdp sticky bar start*/
	$("button.sticky-scroll").on('click', function(){
	    var offTop = $("#product").offset().top;
		$('html,body').animate({
			scrollTop: offTop
		},500);
	});
	$("button.sticky-cart").on('click', function(){
		var id = $(".productSelect").val();
		var qty = $("#qty").val();
		addtocart(id, qty);
	});
	/*pdp sticky bar end*/

	//stratusoft, fresh clean seas slider
	$(".ul-future").slick({
		slidesToShow: 1,
	  	slidesToScroll: 1,
	  	dots: true,
	  	arrows: false,
	  	infinite: true
	});

	//klaviyo newsletter start
	$("#email_signup #email-address").on('input', function(){
		var email = $.trim($("#email-address").val());
		if(email.length > 0){
			$(this).parent().siblings('button').addClass('btn-active');
		}else{
			$(this).parent().siblings('button').removeClass('btn-active');
		}
	});

	$('#email_signup button').on('click', function(){
		var email = $.trim($("#email-address").val());
		var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
		if(!pattern.test(email)){
			$("#email-error").text("Invalid Email Address").css("color", "#cb4b4b");
			$("#email-error").show();
		}
	});
	//klaviyo newsletter end


	/*generate swatches from select box start*/
	var option = $(".allSelect option:selected").attr("stock");
	//console.log(option);
	$(".allSelect option").each(function(){
	    var option_value = $(this).val();
	    var option_text = $(this).text();
	    var option_text1 = $(this).text();
	    var option_stock = $(this).attr("stock");
	    var variant_price = $(this).attr("variant-price");
	    var variant_compare = $(this).attr("variant-compare");
	    //console.log(option_value, option_text, option_stock);

	    if (option_text == "Small" || option_text == "small") {
    		option_text = "S";
    	}else if(option_text == "Medium" || option_text == "medium"){
    		option_text = "M";
    	}else if(option_text == "Large" || option_text == "large"){
    		option_text = "L";
    	}else if(option_text == "XLarge" || option_text == "Xlarge" || option_text == "xlarge" || option_text == "xLarge"){
    		option_text = "XL";
    	}else if(option_text == "2XLarge" || option_text == "2xlarge" || option_text == "2xLarge" || option_text == "2Xlarge"){
    		option_text = "2XL";
    	}else if(option_text == "3XLarge" || option_text == "3xlarge" || option_text == "3xLarge" || option_text == "3Xlarge"){
    		option_text = "3XL";
    	}else if(option_text == "4XLarge" || option_text == "4xlarge" || option_text == "4xLarge" || option_text == "4Xlarge"){
    		option_text = "4XL";
    	}else if(option_text == "5XLarge" || option_text == "5xlarge" || option_text == "5xLarge" || option_text == "5Xlarge"){
    		option_text = "5XL";
    	}else{
    		option_text;
    	}
	   
	   	if (option_text.includes(" / ")) {
	   		var option_value_split = option_text.split(" / ");
	    	//console.log(option_value_split[0], option_value_split[1]);

	    	if (option_value_split[1] == "Small" || option_value_split[1] == "small") {
	    		option_value_split[1] = "S";
	    	}else if(option_value_split[1] == "Medium" || option_value_split[1] == "medium"){
	    		option_value_split[1] = "M";
	    	}else if(option_value_split[1] == "Large" || option_value_split[1] == "large"){
	    		option_value_split[1] = "L";
	    	}else if(option_value_split[1] == "XLarge" || option_value_split[1] == "Xlarge" || option_value_split[1] == "xlarge" || option_value_split[1] == "xLarge"){
	    		option_value_split[1] = "XL";
	    	}else if(option_value_split[1] == "2XLarge" || option_value_split[1] == "2xlarge" || option_value_split[1] == "2xLarge" || option_value_split[1] == "2Xlarge"){
	    		option_value_split[1] = "2XL";
	    	}else if(option_value_split[1] == "3XLarge" || option_value_split[1] == "3xlarge" || option_value_split[1] == "3xLarge" || option_value_split[1] == "3Xlarge"){
	    		option_value_split[1] = "3XL";
	    	}else if(option_value_split[1] == "4XLarge" || option_value_split[1] == "4xlarge" || option_value_split[1] == "4xLarge" || option_value_split[1] == "4Xlarge"){
	    		option_value_split[1] = "4XL";
	    	}else if(option_value_split[1] == "5XLarge" || option_value_split[1] == "5xlarge" || option_value_split[1] == "5xLarge" || option_value_split[1] == "5Xlarge"){
	    		option_value_split[1] = "5XL";
	    	}else{
	    		option_value_split[1];
	    	}

	    	var swatch_name = option_text.split(" / ");
	    	if (swatch_name[1] == "Small" || swatch_name[1] == "small") {
	    		swatch_name[1] = "Small";
	    	}else if(swatch_name[1] == "Medium" || swatch_name[1] == "medium"){
	    		swatch_name[1] = "Medium";
	    	}else if(swatch_name[1] == "Large" || swatch_name[1] == "large"){
	    		swatch_name[1] = "Large";
	    	}else if(swatch_name[1] == "XLarge" || swatch_name[1] == "Xlarge" || swatch_name[1] == "xlarge" || swatch_name[1] == "xLarge"){
	    		swatch_name[1] = "XLarge";
	    	}else if(swatch_name[1] == "2XLarge" || swatch_name[1] == "2xlarge" || swatch_name[1] == "2xLarge" || swatch_name[1] == "2Xlarge"){
	    		swatch_name[1] = "2XLarge";
	    	}else if(swatch_name[1] == "3XLarge" || swatch_name[1] == "3xlarge" || swatch_name[1] == "3xLarge" || swatch_name[1] == "3Xlarge"){
	    		swatch_name[1] = "3XLarge";
	    	}else if(swatch_name[1] == "4XLarge" || swatch_name[1] == "4xlarge" || swatch_name[1] == "4xLarge" || swatch_name[1] == "4Xlarge"){
	    		swatch_name[1] = "4XLarge";
	    	}else if(swatch_name[1] == "5XLarge" || swatch_name[1] == "5xlarge" || swatch_name[1] == "5xLarge" || swatch_name[1] == "5Xlarge"){
	    		swatch_name[1] = "5XLarge";
	    	}else{
	    		swatch_name[1];
	    	}

	    	if((option_value_split[0] === "crew") || (option_value_split[0] === "Crew")){
	    		//console.log(option_value_split[0]);
	    		$(".swatches-div .neck-size-parent .crew-tab").append(`
	    			<div data-value="${swatch_name[1]}" class="swatch-element ${option_stock}">
	    				<input variant-price="${variant_price}" variant-compare="${variant_compare}" variant-id="${option_value}" id="swatch-crew-${swatch_name[1].toLowerCase()}" type="radio" name="option-1" value="${swatch_name[1]}" />
	    				<label radio-value="Neck Style" for="swatch-crew-${swatch_name[1].toLowerCase()}" class="size-label">${option_value_split[1]}</label>
	    			</div>
	    		`);

	    		//on collection page
	    		// $(".swatch-boxes-ul.swatch-crew-tab").append(`
	    		// 	<div variant-id="${option_value}" class="swatch-box ${option_stock}">
	    		// 		<span>${option_value_split[1]}</span>
	    		// 	</div>
	    		// `);
	    	}else if((option_value_split[0] === "v-neck") || (option_value_split[0] === "V-Neck") || (option_value_split[0] === "V-neck") || (option_value_split[0] === "v-Neck")){
	    		//console.log(option_value_split[0]);
	    		$(".swatches-div .neck-size-parent .v-neck-tab").append(`
	    			<div data-value="${swatch_name[1]}" class="swatch-element ${option_stock}">
	    				<input variant-price="${variant_price}" variant-compare="${variant_compare}" variant-id="${option_value}" id="swatch-v-neck-${swatch_name[1].toLowerCase()}" type="radio" name="option-1" value="${swatch_name[1]}" />
	    				<label radio-value="Neck Style" for="swatch-v-neck-${swatch_name[1].toLowerCase()}" class="size-label">${option_value_split[1]}</label>
	    			</div>
	    		`);

	    		//on collection page
	    		// $(".swatch-boxes-ul.swatch-v-neck-tab").append(`
	    		// 	<div variant-id="${option_value}" class="swatch-box ${option_stock}">
	    		// 		<span>${option_value_split[1]}</span>
	    		// 	</div>
	    		// `);
	    	}
	    }else{
	    	//console.log(option_text);
	    	$(".swatches-div .swatch-parent").append(`
	    		<div data-value="${option_text1}" class="swatch-element ${option_text1.toLowerCase()} ${option_stock}">
	    			<input variant-price="${variant_price}" variant-compare="${variant_compare}" variant-id="${option_value}" id="swatch-${option_text1.toLowerCase()}" type="radio" name="option-0" value="${option_text1}" />
	    			<label radio-value="Size" for="swatch-${option_text1.toLowerCase()}" class="size-label">${option_text}</label>
	    		</div>
	    	`);
	    }
	});
	/*generate swatches from select box end*/

	/*generate swatches tab start*/
	$(".neck-parent input[type='radio']").change(function() {
		// Check for active
	    $(".neck-size-parent .swatch-parent").removeClass("active-swatch");
	    $(this).parent().addClass("active-swatch");

	    // Display active tab
	    let currtab = $(this).parent().attr("data-value");
	    //console.log(currtab);
	    //console.log(currentTab);
	    $(".neck-size-parent .swatch-parent").hide();
	    $("."+currtab+"-tab").show();
	    return false;
	});
	/*generate swatches tab end*/


	/*cookie size select start*/
	function setCookie(name,value,days) {
	    var expires = "";
	    if (days) {
	        var date = new Date();
	        date.setTime(date.getTime() + (days*24*60*60*1000));
	        expires = "; expires=" + date.toUTCString();
	    }
	    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	}
	function getCookie(name) {
	    var nameEQ = name + "=";
	    var ca = document.cookie.split(';');
	    for(var i=0;i < ca.length;i++) {
	        var c = ca[i];
	        while (c.charAt(0)==' ') c = c.substring(1,c.length);
	        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	    }
	    return null;
	}


	var size_swatch = getCookie("size-swatch");
	//console.log("size_swatch:" +size_swatch);
	var dataval = "";
	var button_element = $("button[type='submit'].add-to-cart");

	$(".size-parent .swatch-element.available input:radio[name=option-0]").change(function(){
	    val = $(this).val();
	    if (val) {
	    	$(".size-swatch-name").text(val);

	    	setCookie("size-swatch", val, 1); //set "size-swatch" cookie, expires in 1 day

	    	dataval = $(this).parent().attr("data-value");
	    	//console.log("data: "+dataval);
	    	//dataval.input
	    	var check = $(this).attr('checked', true);
	    	//console.log(check);
	    }
	});

	//gift card product
	var gift_price = $(".gift-card-only .swatch-element.available:first input:radio[name=option-0]").attr("variant-price");
	$(".col-45 li label.price, #sticky-product .addcart-price span.single-price, .col-55 li label.price").text(gift_price);

	$(".gift-card-only .swatch-element.available input:radio[name=option-0]").change(function(){
	    val = $(this).val();
	    if (val) {
	    	$(".gift-swatch-name").text(val);
	    }

	    //change price & slide based on denomination
	    var gift_price = $(this).attr("variant-price");
	    //console.log(gift_price);
	    $(".col-45 li label.price, #sticky-product .addcart-price span.single-price, .col-55 li label.price").text(gift_price);

        var slideno = $(this).parent().index();
        var slider = $(".thumbnail-slider");
        $(".thumbnail-slider .thumb[data-slick-index='"+slideno+"']").click();
        //console.log(slideno);
	});



	//product page varaint default checker
	var swatchValue = $(".size-parent .swatch-element.available input:radio[name=option-0]:checked").val();
	//console.log("swatchValue:" +swatchValue);

	if (size_swatch != null) {
		if ($(".size-parent .swatch-element.available input:radio[name=option-0][value="+size_swatch+"]")) {
			//console.log("!=null");
			$($(".size-parent .swatch-element.available input:radio[name=option-0][value="+size_swatch+"]")).siblings("label").click();
			$(".size-parent .swatch-element.available input:radio[name=option-0][value="+size_swatch+"]").attr("checked", true);
			$(".size-swatch-name").text(size_swatch);

			// var variant_price = $($(".size-parent .swatch-element.available input:radio[name=option-0][value="+size_swatch+"]")).attr("variant-price");
			// var variant_compare = $($(".size-parent .swatch-element.available input:radio[name=option-0][value="+size_swatch+"]")).attr("variant-compare");
			// console.log(variant_price, variant_compare);

			// if (variant_compare == "undefined"){
			// 	$(".col-45 li label.price, #sticky-product .addcart-price span.desktop-only, .col-55 li label.price").removeClass("compare-price");

			// 	$(".col-45 li label.price del, #sticky-product .addcart-price span.desktop-only del, .col-55 li label.price del").remove();

			// 	$(".col-45 li label.price span, #sticky-product .addcart-price span.desktop-only span, .col-55 li label.price span").text(variant_price);
			// }else{
			// 	$(".col-45 li label.price, #sticky-product .addcart-price span.desktop-only, .col-55 li label.price").addClass("compare-price");
				
			// 	$(".col-45 li label.price, .col-55 li label.price").html("<del>"+variant_compare+"</del><span>"+variant_price+"</span>");

			// 	$("#sticky-product .addcart-price span.desktop-only").html("<del>"+variant_compare+"</del><span class='single-price'>"+variant_price+"</span>")
			// }

			//pdp sticky add to cart
			//$("button.sticky-scroll").hide();
			//$("button.sticky-cart").show();

			var variant_id = $(".size-parent .swatch-element.available input:radio[name=option-0][value="+size_swatch+"]").attr("checked", true).attr("variant-id");
			$(".productSelect").val(variant_id);
		}
	}
	if ($(".swatch-element.available input:radio[name=option-0]:checked").val() != $(".size-swatch-name").text()) {
		//console.log("= null");
		//$($(".swatch-element.available:first input:radio[name=option-0]")).siblings("label").click();
		//$(".swatch-element.available:first input:radio[name=option-0]").attr('checked', true);
		$(".size-swatch-name").text("");

		//var variant_id = $(".swatch-element.available:first input:radio[name=option-0]").attr("checked", true).attr("variant-id");
		//$(".productSelect").val(variant_id);
	}

	/*cookie size select end*/


	/*pdp swatches click show button text start*/
	
	if ($(".size-parent input[type='radio']:checked").length > 0){
		button_element.text("Add To Cart").removeAttr("disabled");
		//console.log("checked");
		//pdp sticky add to cart
		$("button.sticky-scroll").hide();
		$("button.sticky-cart").show();
	}

	// single product size swatches
	$(".size-parent input[type='radio'], .gift-card-only input[type='radio']").change(function() {
		//console.log("changed");
		var current = $(this);
		var product_url = window.location.href.split('?')[0];
		var variant_id = "";
		var target_url = "";

		if (($(".size-parent input[type='radio']:checked").length > 0) || ($(".gift-card-only input[type='radio']:checked").length > 0)){

			var variant_price = $(this).attr("variant-price");
			var variant_compare = $(this).attr("variant-compare");
			if (variant_compare == "undefined"){
				$(".col-45 li label.price, #sticky-product .addcart-price span.desktop-only, .col-55 li label.price, #sticky-product .title-color span.price").removeClass("compare-price");

				$(".col-45 li label.price del, #sticky-product .addcart-price span.desktop-only del, .col-55 li label.price del, #sticky-product .title-color span.price del").remove();

				$(".col-45 li label.price span, #sticky-product .addcart-price span.desktop-only span, .col-55 li label.price span, #sticky-product .title-color span.price span").text(variant_price);
			}else{
				$(".col-45 li label.price, #sticky-product .addcart-price span.desktop-only, .col-55 li label.price, #sticky-product .title-color span.price").addClass("compare-price");
				
				$(".col-45 li label.price, .col-55 li label.price, #sticky-product .title-color span.price").html("<del>"+variant_compare+"</del><span>"+variant_price+"</span>");

				//desktop
				$("#sticky-product .addcart-price span.desktop-only").html("<del>"+variant_compare+"</del><span class='single-price'>"+variant_price+"</span>");

				//mobile
				$("#sticky-product .title-color span.price").html("<del>"+variant_compare+"</del><span>"+variant_price+"</span>");
			}

			//checking soldout varaint
			if ($(".swatch-element.soldout input[type='radio']:checked").length > 0){
				//console.log("soldout variant");
				button_element.text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn");
				$("button.sticky-scroll").text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn").show();
				$("button.sticky-cart").hide();
			}else{
				//console.log("available variant");
				button_element.text("Add To Cart").removeAttr("disabled").removeClass("soldout-btn");
				$("button.sticky-scroll").text("Select Size").removeAttr("disabled").removeClass("soldout-btn").hide();
				$("button.sticky-cart").show();
			}
			//console.log("clicked now");
			//pdp sticky add to cart
			// $("button.sticky-scroll").hide();
			// $("button.sticky-cart").show();

			var variant_id = current.attr("variant-id");
			$(".productSelect").val(variant_id);
			target_url = product_url+"?variant="+variant_id;
		}
		window.history.pushState({url: target_url},'', target_url);
	});

	//neck-size swatches
	$(".neck-parent input[type='radio']").change(function() {
		$(".neck-swatch-name").text($(this).val());
		button_element.text("Select Size");
	});

	$(".neck-size-parent input[type='radio']").change(function() {
		//console.log("changed");
		var current = $(this);
		var product_url = window.location.href.split('?')[0];
		var variant_id = "";
		var target_url = "";
		var val = $(this).val();
		//console.log(val);
		$(".neck-size-name").text(val);
			
		if ($(".neck-size-parent input[type='radio']:checked").length > 0){
			//button_element.text("Add To Cart").removeAttr("disabled");
			//var val = current.parent().attr("data-value");
			$("button.sticky-scroll").text("Select Size");
			var variant_id = current.attr("variant-id");
			$(".productSelect").val(variant_id);
			target_url = product_url+"?variant="+variant_id;
		}

		//checking soldout varaint
		if ($(".swatch-element.soldout input[type='radio']:checked").length > 0){
			//console.log("soldout variant");
			button_element.text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn");
			$("button.sticky-scroll").text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn").show();
			$("button.sticky-cart").hide();
		}else{
			//console.log("available variant");
			button_element.text("Add To Cart").removeAttr("disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").text("Select Size").removeAttr("disabled").removeClass("soldout-btn").hide();
			$("button.sticky-cart").show();
		}

		window.history.pushState({url: target_url},'', target_url);

	});
	/*pdp swatches click show button text end*/	


	/*neck,size tab radios button text change start*/
	$(".only-neck-size input[type='radio']").change(function() {
		if (($(".neck-parent .crew input[type='radio']:checked").length == 0)){
			button_element.text("Select Size").attr("disabled", "disabled").removeClass("soldout-btn");;
			$("button.sticky-scroll").text("Select Size").removeAttr("disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").show();
			$("button.sticky-cart").hide();
		}else if(($(".neck-parent .v-neck input[type='radio']:checked").length == 0)){
			button_element.text("Select Size").attr("disabled", "disabled").removeClass("soldout-btn");;
			$("button.sticky-scroll").text("Select Size").removeAttr("disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").show();
			$("button.sticky-cart").hide();
		}

		if (($(".neck-size-parent .crew-tab input[type='radio']:checked").length > 0) && ($(".neck-parent .crew input[type='radio']:checked").length == 0)){
			button_element.text("Select Neck Style").attr("disabled", "disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").text("Select Neck Style").removeAttr("disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").show();
			$("button.sticky-cart").hide();
		}else if(($(".neck-size-parent .v-neck-tab input[type='radio']:checked").length > 0) && ($(".neck-parent .v-neck-tab input[type='radio']:checked").length == 0)){
			button_element.text("Select Neck Style").attr("disabled", "disabled").removeClass("soldout-btn");;
			$("button.sticky-scroll").text("Select Neck Style").removeAttr("disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").show();
			$("button.sticky-cart").hide();
		}

		if ($(".neck-parent .crew input[type='radio']:checked").length > 0){
			button_element.text("Select Size").attr("disabled", "disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").text("Select Size").removeAttr("disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").show();
			$("button.sticky-cart").hide();
		}else if ($(".neck-parent .v-neck input[type='radio']:checked").length > 0){
			button_element.text("Select Size").attr("disabled", "disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").text("Select Size").removeAttr("disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").show();
			$("button.sticky-cart").hide();
		}

		var variant_price = $(this).attr("variant-price");
		var variant_compare = $(this).attr("variant-compare");

		if (($(".neck-parent .crew input[type='radio']:checked").length > 0) && ($(".neck-size-parent .crew-tab input[type='radio']:checked").length > 0)){
			//console.log("clicked");


			if (variant_compare == "undefined"){
				//console.log("yes");
				$(".col-45 li label.price, #sticky-product .addcart-price span.desktop-only, .col-55 li label.price, #sticky-product .title-color span.price").removeClass("compare-price");

				$(".col-45 li label.price del, #sticky-product .addcart-price span.desktop-only del, .col-55 li label.price del, #sticky-product .title-color span.price del").remove();

				$(".col-45 li label.price span, #sticky-product .addcart-price span.desktop-only span, .col-55 li label.price span, #sticky-product .title-color span.price span").text(variant_price);
			}else{
				//console.log("no");
				$(".col-45 li label.price, #sticky-product .addcart-price span.desktop-only, .col-55 li label.price, #sticky-product .title-color span.price").addClass("compare-price");
				
				$(".col-45 li label.price, .col-55 li label.price").html("<del>"+variant_compare+"</del><span>"+variant_price+"</span>");

				//desktop
				$("#sticky-product .addcart-price span.desktop-only").html("<del>"+variant_compare+"</del><span class='single-price'>"+variant_price+"</span>");

				//mobile
				$("#sticky-product .title-color span.price").html("<del>"+variant_compare+"</del><span>"+variant_price+"</span>");
			}

			if ($(".swatch-element.soldout input[type='radio']:checked").length > 0){
				//console.log("soldout variant");
				button_element.text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn");
				$("button.sticky-scroll").text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn").show();
				$("button.sticky-cart").hide();
			}else{
				//console.log("available variant");
				button_element.text("Add To Cart").removeAttr("disabled").removeClass("soldout-btn");
				$("button.sticky-scroll").text("Select Size").removeAttr("disabled").removeClass("soldout-btn").hide();
				$("button.sticky-cart").show();
			}

			//button_element.text("Add To Cart").removeAttr("disabled");
			//pdp sticky add to cart
			//$("button.sticky-scroll").hide();
			//$("button.sticky-cart").show();
		}else if(($(".neck-parent .v-neck input[type='radio']:checked").length > 0) && ($(".neck-size-parent .v-neck-tab input[type='radio']:checked").length > 0)){
			//console.log("clicked");


			if (variant_compare == "undefined"){
				$(".col-45 li label.price, #sticky-product .addcart-price span.desktop-only, .col-55 li label.price, #sticky-product .title-color span.price").removeClass("compare-price");

				$(".col-45 li label.price del, #sticky-product .addcart-price span.desktop-only del, .col-55 li label.price del, #sticky-product .title-color span.price del").remove();

				$(".col-45 li label.price span, #sticky-product .addcart-price span.desktop-only span, .col-55 li label.price span, #sticky-product .title-color span.price span").text(variant_price);
			}else{
				$(".col-45 li label.price, #sticky-product .addcart-price span.desktop-only, .col-55 li label.price, #sticky-product .title-color span.price").addClass("compare-price");
				
				$(".col-45 li label.price, .col-55 li label.price, #sticky-product .title-color span.price").html("<del>"+variant_compare+"</del><span>"+variant_price+"</span>");

				//desktop
				$("#sticky-product .addcart-price span.desktop-only").html("<del>"+variant_compare+"</del><span class='single-price'>"+variant_price+"</span>");

				//mobile
				$("#sticky-product .title-color span.price").html("<del>"+variant_compare+"</del><span>"+variant_price+"</span>");
			}

			if ($(".swatch-element.soldout input[type='radio']:checked").length > 0){
				//console.log("soldout variant");
				button_element.text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn");
				$("button.sticky-scroll").text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn").show();
				$("button.sticky-cart").hide();
			}else{
				//console.log("available variant");
				button_element.text("Add To Cart").removeAttr("disabled").removeClass("soldout-btn");
				$("button.sticky-scroll").text("Select Size").removeAttr("disabled").removeClass("soldout-btn").hide();
				$("button.sticky-cart").show();
			}


			//button_element.text("Add To Cart").removeAttr("disabled");
			//pdp sticky add to cart
			//$("button.sticky-scroll").hide();
			//$("button.sticky-cart").show();
		}
	});
	/*neck,size tab radois button text change end*/

	// our-story team slider on mobile start
	$(".team-ul").slick({
	     slidesToShow: 1,
	     slidesToScroll: 1,
	     autoplay: false,
	     mobileFirst: true,
	     arrows: false,
	     dots: true,
	     infinite: true,
	     variableWidth: false,
	     centerMode: true,
	     cssEase: 'linear',
	     responsive: [
	        {
	           breakpoint: 767,
	           settings: "unslick"
	        }
	     ]
	});
	// our-story team slider on mobile end

	//contact page validation start
	$(".contact-form-submit").on("click", function(){
		var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
		var name = $.trim($("#ContactFormName").val());
		var email = $.trim($("#ContactFormEmail").val());
		//var subject = $.trim($("#ContactFormSubject").val());
		var subject = $.trim($("#ContactFormSubject").find("option:selected").attr('disabled'));
		var message = $.trim($("#ContactFormMessage").val());

        if(name.length == 0){
        	$(".error-name").text("Required").fadeIn();
        	$(".error-name").parent().css("color", "#cb4b4b");
        	$("#ContactFormName").css("border-color", "#cb4b4b");
        }else{
			$(".error-name").text("").fadeOut();
			$(".error-name").parent().css("color", "#242424");
			$("#ContactFormName").css("border-color", "#dbd9d4");
        }

        if(!pattern.test(email) || email.length == 0){
        	$(".error-email").text("Required").fadeIn();
        	$(".error-email").parent().css("color", "#cb4b4b");
        	$("#ContactFormEmail").css("border-color", "#cb4b4b");
        }
        else{
        	$(".error-email").text("").fadeOut();
        	$(".error-email").parent().css("color", "#242424");
        	$("#ContactFormEmail").css("border-color", "#dbd9d4");
        }

        if(subject){
        	$(".error-subject").text("Required").fadeIn();
        	$(".error-subject").parent().css("color", "#cb4b4b");
        	$("#ContactFormSubject").css("border-color", "#cb4b4b");
        }else{
			$(".error-subject").text("").fadeOut();
			$(".error-subject").parent().css("color", "#242424");
			$("#ContactFormSubject").css("border-color", "#dbd9d4");
        }
        // if(!subject){
        // 	console.log("yes");
        // }else{
        // 	console.log("no");
        // }

        if(message.length == 0 ){
        	$(".error-message").text("Required").fadeIn();
        	$(".error-message").parent().css("color", "#cb4b4b");
        	$("#ContactFormMessage").css("border-color", "#cb4b4b");
        }else{
			$(".error-message").text("").fadeOut();
			$(".error-message").parent().css("color", "#242424");
			$("#ContactFormMessage").css("border-color", "#dbd9d4");
        }

        if(name.length != 0 && pattern.test(email) && email.length != 0  && !subject && message.length !=0){
        	$(".contact-form-act-submit").click();
        }

	});
	//contact page validation end


	/*var key1 = $(".swatch-parent:eq(0) input[type='radio']:checked").val();
	var key2 = $(".swatch-parent:eq(1) input[type='radio']:checked").val();
	//console.log(key1+" / "+key2);

	$(".swatch-parent input[type='radio']").change(function() {
		key1 = $(".swatch-parent:eq(0) input[type='radio']:checked").val();
		key2 = $(".swatch-parent:eq(1) input[type='radio']:checked").val();
		key2slash = " / "+key2;

		var combine = "";
		combine = key1+key2slash;
		//console.log(combine);

		var product_url = window.location.href.split('?')[0];
		var variant_id = "";
		var target_url = "";

		if (key1 != null & key2!= null) {
			$("select.productSelect option").filter(function(){
				return $(this).text() === combine;
			}).prop('selected', true);
			variant_id = $("select.productSelect").val();
			target_url = product_url+"?variant="+variant_id;
		}else{
			$("select.productSelect option").filter(function(){
				return $(this).text() === key1;
			}).prop('selected', true);
			variant_id = $("select.productSelect").val();
			target_url = product_url+"?variant="+variant_id;
		}
		window.history.pushState({url: target_url},'', target_url);
	});*/
